/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CountryInfo { 
    id: number;
    name: string;
    code: string;
    isTaxReportingEnabled: boolean;
}

